exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span._2omDz{cursor:pointer;font-size:16px;margin:0 8px}", ""]);

// exports
exports.locals = {
	"btn": "_2omDz"
};